// Func = limiting Scope for this file
// ===== vanilla JS window width and height
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth  = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
// =====
var lastScrollTop = 0;
(function(){
	scrollW();
	resizeWindow();
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		// scrollDownAction(20, 'scroll');
		scrollW();
		resizeWindow();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		window.addEventListener('resize', function(){
			resizeWindow();
		});
	};

	//all btn
	if(document.getElementsByClassName('btn').length > 0){
		let allBtn = document.getElementsByClassName('btn');
		let allBtnNum = document.getElementsByClassName('btn').length;
		for(let i=0; i < allBtnNum; i++){
			if(!allBtn[i].classList.contains('btnSubmit')){
				let innerBtn = allBtn[i].innerHTML;
				allBtn[i].innerHTML = '<span>' + innerBtn + '</span>';
			}
		}
	}

	//Intersection for parallax effect
	if(!(window.ActiveXObject) && "ActiveXObject" in window ){
		//is explorer
		if(document.getElementsByClassName('toanimate').length > 0 ){
			let alltoanimate = document.getElementsByClassName('toanimate');
			for(let y=0; y < alltoanimate.length; y++){
				alltoanimate[y].classList.add('animate-fade')
				alltoanimate[y].classList.remove('toanimate');
			}
		}
	} else {
		if(document.getElementsByClassName('toanimate').length > 0 ){
			if(window.innerWidth > 1090 ){
				let options = {
					root : null,
					rootMargin : '0px',
					threshold : 0.4
				}
				
				function handlerParallax(entries, observer){
					for(let entry of entries){
						if(entry.isIntersecting){
							entry.target.classList.add('animated');
						} 
					}
				}
				let allparallax = document.getElementsByClassName('toanimate')
				for(let  j = 0; j < allparallax.length; j++ ){
					let observerParallax = new IntersectionObserver(handlerParallax, options)
					observerParallax.observe(allparallax[j])
				}
			} else {
				let alltoanimateNew = document.getElementsByClassName('toanimate');
				let alltoanimateL = alltoanimateNew.length;
				
				for(let m = 0; m < alltoanimateL; m++){
					alltoanimateNew[m].classList.add('animate-fade')
					//alltoanimateNew[m].classList.remove('toanimate');
				}
			}
		}
	}

	//open booking widget
	let bookingCta = document.getElementsByClassName('js-bookingcta')[0];
	let bookingBlock = document.getElementsByClassName('booking-block-js')[0];
	let bookingClose = document.getElementsByClassName('close-js')[0];

	bookingCta.addEventListener('click', function(){
		bookingBlock.classList.add('open');
	});
	bookingClose.addEventListener('click', function(){
		bookingBlock.classList.remove('open');
	});

	//booking url change
	let bookingForm = document.getElementById('booking-form');
	bookingForm.addEventListener('submit', function(event){
		event.preventDefault();
		let bookingUrl = this.getAttribute('action');
		let checkinDate = document.getElementById('altCheckin').getAttribute('value');
		let checkoutDate = document.getElementById('altCheckout').getAttribute('value');
		let bookingLink = bookingUrl + '?checkin=' + checkinDate + '&checkout=' + checkoutDate;
		// OLD bookingLink = decorateUrlGA4(bookingLink);
		// OLD window.open(bookingLink,'_blank');
		decorateUrlGA4New(bookingLink);
		bookingBlock.classList.remove('open');
	});

	//change meetings word in form
    if(document.getElementById('formRFP')){
        let rfpForm = document.getElementById('formRFP');
        let rfplengend = rfpForm.getElementsByTagName('legend')[1];
        rfplengend.innerHTML = 'Event Information';
        let rfpLabels = rfpForm.getElementsByTagName('label');
        let allrfpLabels = rfpLabels.length;
    
        for(let i = 0; i < allrfpLabels; i++){
            if(rfpLabels[i].innerHTML == 'Meeting Date: *'){
                rfpLabels[i].innerHTML = 'Event Date: *'
            }
        }
    }


	$(document).ready(function () {
		$( "#CheckIn" ).datepicker({
			changeMonth: true,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			minDate: 0,
			altField:'#altCheckin',
			altFormat: "yy-mm-dd",
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			dateFormat: 'mm/dd/yy',
			changeMonth: true,
			numberOfMonths: 1,
			altField:'#altCheckout',
			altFormat: "yy-mm-dd",
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
	});

	

}());

$('.logo-slider__slider').slick({
	slidesToShow: 3,
	arrows: true,
	dots: false,
	infinite: true,
	speed: 700,
	accessibility: true
});

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow(){
	// ===== vanilla JS window width and height
	var w=window,
	d=document,
	e=d.documentElement,
	g=d.getElementsByTagName('body')[0],
	windowWidth  = w.innerWidth||e.clientWidth||g.clientWidth,
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
	// =====

	//home-slider hero
	if(document.getElementById('home')){
		let allSlides = document.getElementsByClassName('slide-img');
		let allSlidesNum = allSlides.length;
		for(let i=0; i < allSlidesNum; i++){
			allSlides[i].style.height = windowHeight + 'px';
		}
	}

}

// Get in Touch Form Submit CTA Adjustment

if( document.querySelector('#getintouch-form') ) {

	const form = document.querySelector('#getintouch-form');
	const btn = form.querySelector('.btn');
	const firstSpan = btn.querySelector('span span');
	const secondSpan = btn.querySelector('span');
	
	 if(firstSpan) {
		firstSpan.remove();
	}
	if(secondSpan) {
		secondSpan.textContent = 'Submit';
	}
}